

function formatDate(v, format = '') {
  if (!v) return '';
  let d = v;
  let fDate = format;
  if (typeof v === 'string') {
    if (v.indexOf('/Date(') > -1) d = new Date(parseInt(v.replace('/Date(', '').replace(')/', ''), 10));
    else d = new Date(Date.parse(v.replace(/-/g, '/').replace('T', ' ').split('.')[0])); // .split(".")[0] 用来处理出现毫秒的情况，截取掉.xxx，否则会出错
  }
  let o = {
    'M+': d.getMonth() + 1, // month
    'd+': d.getDate(), // day
    'h+': d.getHours(), // hour
    'm+': d.getMinutes(), // minute
    's+': d.getSeconds(), // second
    'q+': Math.floor((d.getMonth() + 3) / 3), // quarterjsoncc1
    'S': d.getMilliseconds() // millisecond
  };
  if (/(y+)/.test(format)) {
    fDate = fDate.replace(RegExp.$1, String(d.getFullYear()).substr(4 - RegExp.$1.length));
  }
  $.each(o, function (key, value) {
    if (new RegExp(`(${key})`).test(format)) {
      let str = value.toString();
      fDate = fDate.replace(RegExp.$1, RegExp.$1.length === 1 ? str : `00${str}`.substr(String(str).length));
    }
  });
  return fDate;
}

function doubleNumber(str) {
  return str.length <= 1 ? '0' + str : str;
}

function RndNum(n) {
  let rnd = '';
  for (let i = 0; i < n; i++) {
    rnd += Math.floor(Math.random() * 10);
  }
  return rnd;
}

function modalToast(msg1, fsh1) {
  let toast = document.getElementById('app-toast');
  let chd = toast.children;
  for(let i = 0; i < chd.length; i++) {
    chd[i].classList.add('hide');
  }
  toast.className = '';

  if(fsh1) {
    let timer;
    let time = 5;
    let fsh = toast.querySelector('.fsh');
    toast.classList.add('fsh');
    fsh.classList.remove('hide');
    fsh.querySelector('.ti').innerHTML = time + 's后自动关闭';
    timer = setInterval(() => {
      time--;
      if(time === 0) {
        clearInterval(timer);
        toast.classList.add('hide');
        fsh.classList.add('hide');
      } else {
        fsh.querySelector('.ti').innerHTML = time + 's后自动关闭';
      }
    }, 1000)
    return;
  }
  if (msg1) {
    let msg = toast.querySelector('.msg');
    msg.innerHTML = msg1;
    toast.classList.add('msg');
    msg.classList.remove('hide');
    setTimeout(() => { msg.classList.add('fadein') }, 50);
    toast.addEventListener('webkitAnimationEnd', function () {
      toast.classList.add('hide');
      msg.classList.add('hide');
      msg.classList.remove('fadein');
    });
    toast.addEventListener('animationEnd', function () {
      toast.classList.add('hide');
      msg.classList.add('hide');
      msg.classList.remove('fadein');
    });
  }
}

function selectFileRule(item, cb) {
  let iType = item.type.toLowerCase();
  let myIndex = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"].indexOf(iType);
  if (myIndex !== -1) {
    console.log('文件大小。。', item.size, item);
    if (Math.ceil(item.size / (6 * 1024 * 1024)) <= 1) {
      cb && cb(item, myIndex);
    } else {
      modalToast(`文件大小不能超过6M`);
      return;
    }
  } else {
    modalToast(`仅支持doc、docx、pdf格式文件上传`);
    return;
  }
}

function deleteUploadify() {
  var uploadElem = document.getElementById('GlobalWebUploadFile');
  if(uploadElem) {
    document.body.removeChild(uploadElem);
  }
  // document.getElementById('GlobalWebUploadFile') && document.getElementById('GlobalWebUploadFile').remove();
}

function uploadify(cb) {
  let guf = 'GlobalWebUploadFile';
  let S = () => {
    return document.getElementById(guf);
  }
  if (S(guf) === null) {
    let input = document.createElement('input');
    input.id = guf;
    input.name = guf;
    input.type = 'file';
    input.style.display = 'none';
    //微信内置浏览器无法打开文件
    let sUserAgent = navigator.userAgent.toLowerCase();
    if (!(sUserAgent.indexOf('micromessenger') > -1 && sUserAgent.indexOf('android') > -1)) {
      input.accept = '.pdf,.doc,.docx';
    }
    document.body.appendChild(input);
    S(guf).addEventListener('change', (e) => {
      if (e.target.files.length !== 0) {
        selectFileRule(e.target.files[0], cb);
      }
      input.value = '';
    });
    // 还要拖拽的时间
  }
  S(guf).click();
}


export default {
  formatDate,
  doubleNumber,
  RndNum,
  modalToast,
  selectFileRule,
  deleteUploadify,
  uploadify
}


// WEBPACK FOOTER //
// ./src/components/common/common.js